import React, { useEffect, useState } from 'react';
import api from '../api';
import { useAuth } from '../contexts/AuthContext';
import { useSortedPaginated, SortableTh, Pagination } from '../components/TableControls';

export default function Items() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [catFilter, setCatFilter] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ name: '', category: '' });
  const [msg, setMsg] = useState('');
  const [forceDeleteItem, setForceDeleteItem] = useState(null);
  const { paginated, sortKey, sortDir, setSort, page, setPage, perPage, setPerPage, total } = useSortedPaginated(items, 'name');

  const load = () => {
    const params = {};
    if (search) params.search = search;
    if (catFilter) params.category = catFilter;
    api.get('/items', { params }).then(r => setItems(r.data));
    api.get('/items/categories').then(r => setCategories(r.data));
  };

  useEffect(() => { load(); }, [search, catFilter]);

  const openCreate = () => { setEditItem(null); setForm({ name: '', category: '' }); setShowModal(true); };
  const openEdit = (item) => { setEditItem(item); setForm({ name: item.name, category: item.category || '' }); setShowModal(true); };

  const save = async (e) => {
    e.preventDefault();
    if (editItem) {
      await api.put(`/items/${editItem.id}`, form);
    } else {
      await api.post('/items', form);
    }
    setShowModal(false);
    load();
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`¿Eliminar artículo "${item.name}"?`)) return;
    setMsg('');
    setForceDeleteItem(null);
    try {
      const res = await api.delete(`/items/${item.id}`);
      if (res.data.action === 'archived') {
        setForceDeleteItem(item);
      }
      setMsg(res.data.message);
      load();
    } catch (err) {
      setMsg(err.response?.data?.detail || 'Error');
    }
  };

  const handleForceDelete = async () => {
    if (!forceDeleteItem) return;
    if (!window.confirm(`¿Eliminar permanentemente "${forceDeleteItem.name}" y TODO su historial de transacciones? Esta acción no se puede deshacer.`)) return;
    setMsg('');
    try {
      const res = await api.delete(`/items/${forceDeleteItem.id}?force=true`);
      setMsg(res.data.message);
      setForceDeleteItem(null);
      load();
    } catch (err) {
      setMsg(err.response?.data?.detail || 'Error');
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Artículos</h1>
        {user?.role === 'admin' && <button className="btn btn-primary" onClick={openCreate}>Agregar Artículo</button>}
      </div>

      {msg && (
        <div className={`alert ${msg.includes('archived') ? 'alert-warning' : msg.includes('deleted') ? 'alert-success' : 'alert-danger'}`}>
          {msg}
          {forceDeleteItem && (
            <span>
              {' '}
              <button
                className="btn btn-sm btn-danger"
                style={{ marginLeft: 8 }}
                onClick={handleForceDelete}
              >
                Eliminar Forzado
              </button>
            </span>
          )}
        </div>
      )}

      <div className="filter-bar">
        <input placeholder="Buscar artículos..." value={search} onChange={e => setSearch(e.target.value)} />
        <select value={catFilter} onChange={e => setCatFilter(e.target.value)}>
          <option value="">Todas las Categorías</option>
          {categories.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div className="card">
        <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <SortableTh colKey="name" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Nombre</SortableTh>
                <SortableTh colKey="category" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Categoría</SortableTh>
                {user?.role === 'admin' && <th>Acciones</th>}
              </tr>
            </thead>
            <tbody>
              {paginated.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.category || '-'}</td>
                  {user?.role === 'admin' && (
                    <td>
                      <button className="btn btn-sm btn-secondary" onClick={() => openEdit(item)}>Editar</button>
                      {' '}
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item)}>Eliminar</button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editItem ? 'Editar Artículo' : 'Agregar Artículo'}</h2>
            <form onSubmit={save}>
              <div className="form-group">
                <label>Nombre</label>
                <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Categoría</label>
                <input value={form.category} onChange={e => setForm({...form, category: e.target.value})} />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
